import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class EventData<T = any> {
  private _api = inject(FsApi);


  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `events/${id}`,
      query,
      {
        key: 'event',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'events',
      query,
      {
        key: 'events',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `events/${data.id}`,
      data,
      {
        key: 'event',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'events',
      data,
      {
        key: 'event',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `events/${data.id}`,
      data,
      {
        key: 'event',
        ...config,
      },
    );
  }

  public seriesDelete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `events/series/${data.id}`,
      data,
      {
        key: 'event',
        ...config,
      },
    );
  }

  public seriesSave(data: any, config: RequestConfig = {}): Observable<T> {
    return data.id ? this.seriesPut(data) : this.seriesPost(data);
  }

  public seriesPost(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'events/series',
      data,
      {
        key: null,
        ...config,
      },
    );
  }

  public seriesPut(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `events/series/${data.id}`,
      data,
      {
        key: null,
        ...config,
      },
    );
  }

  public seriesInstancePost(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      `events/series/${data.id}/instances`,
      data,
      {
        key: null,
        ...config,
      },
    );
  }

  public seriesInstanceDelete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `events/series/${data.id}/instances`,
      data,
      {
        key: null,
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
